import React from "react";

import HomeIcon from "@mui/icons-material/Home";
import UploadIcon from "@mui/icons-material/Upload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LoginIcon from "@mui/icons-material/Login";
import SettingsIcon from "@mui/icons-material/Settings";
import TransformIcon from "@mui/icons-material/Transform";
import TerminalIcon from "@mui/icons-material/Terminal";
import PasswordIcon from "@mui/icons-material/Password";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import BugReportIcon from "@mui/icons-material/BugReport";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { TableRows } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

export type NavLink = {
	to: string;
	text: string;
	icon?: React.ReactNode;
};

export const USER_LINKS: NavLink[] = [
	{ to: "/home", text: "Home", icon: <HomeIcon /> },
	{ to: "/jobs/dashboard", text: "Jobs", icon: <TableRows /> },
	{ to: "/jobs/submit", text: "Submit Jobs", icon: <UploadIcon /> },
	{ to: "/jobs/ready", text: "Mark Jobs Ready", icon: <CheckCircleIcon /> },
];

export const LOGIN_LINK: NavLink = { to: "/login", text: "Login", icon: <LoginIcon /> };

export const ADMIN_LINKS: NavLink[] = [
	{ to: "/admin/import", text: "Import Settings", icon: <SettingsIcon /> },
	{ to: "/admin/geofile-converter", text: "GeoFile Converter", icon: <TransformIcon /> },
	{ to: "/admin/mission-control-logs", text: "App Logs", icon: <TerminalIcon /> },
	{ to: "/admin/mission-control-passwords-generator", text: "App Passwords", icon: <PasswordIcon /> },
	{ to: "/admin/password-generator", text: "App Login Generator", icon: <VpnKeyIcon /> },
	{ to: "/admin/unmatched-deals", text: "Deal Matching", icon: <LinkIcon /> },
	{ to: "/admin/unmatched-branches", text: "Branch Matching", icon: <AccountTreeIcon /> },
];

// export const SOFTWARE_TESTER_LINKS: NavLink[] = [];

export const DEVELOPER_LINKS: NavLink[] = [
	{ to: "/admin/agrian-issues", text: "Agrian", icon: <BugReportIcon /> },
	{ to: "/admin/data-sendback-issues", text: "Data Sendback", icon: <BugReportIcon /> },
	{ to: "/admin/post-sampling-issues", text: "Post-Sampling", icon: <BugReportIcon /> },
	{ to: "/admin/robots", text: "Robots", icon: <SmartToyIcon /> },
];
